import { UserContact } from 'models/user-contact';
import axios from 'axios';
import { apiService } from './api.service';
import { handleResponse, extractData, handleApiException } from 'helpers/apiResponseHelper';
import { LOCAL_STORAGE_KEYS } from 'common/constants/localStorageKeys';

const exampleUserId = process.env.REACT_APP_TEST_USER_ID;
let currentCustomer: {customerId: number} = {customerId: localStorage.getItem(LOCAL_STORAGE_KEYS.CUSTOMER_ID) ? Number(localStorage.getItem(LOCAL_STORAGE_KEYS.CUSTOMER_ID)): 0};
export const userService = {
    currentCustomer: {},
    getUserInfo,
    getCurrentUser: getCurrentUser,
    getCurrentCustomer: getCurrentCustomer,
    setCurrentCustomer: setCurrentCustomer,
    getUserByPersonalCode
};

function getCurrentUser() {
    return {userId: exampleUserId}
}
function getCurrentCustomer(): {customerId: number} {
    return currentCustomer;
}
function setCurrentCustomer(customer: any): void {
    currentCustomer = {customerId: customer.customerId}
}

async function getUserInfo() {
  return axios.get(apiService.getApiUrl() + '/users/current')
    .then(handleResponse)
    .then(extractData)
    .catch(handleApiException);
}

async function getUserByPersonalCode(personalCode: string) {
    return axios.get(apiService.getApiUrl() + '/users/' + personalCode)
        .then(handleResponse)
        .then(extractData)
        .catch(handleApiException);
}

export const mapUserContactToCustomer = (contact: UserContact) => {
    return {
        contactId: contact.id,
        name: contact.customerName,
        roles: contact.customerRoles,
        registryNumber: contact.registryNumber,
        vatRegistryNumber: contact.vatRegistryNumber,
        searchCode: contact.searchCode,
        groupId: contact.groupId,
        email: contact.email,
        phone: contact.phone,
        mobileNumber: contact.mobileNumber,
        address: contact.address,
        city: contact.city,
        zip: contact.zip,
        county: contact.county,
        customerBalanceLimit: contact.customerBalanceLimit,
        creditUsed: contact.creditUsed,
        isPerson: contact.isPerson,
        apartmentAssociation: contact.apartmentAssociation,
        isCompany: contact.isCompany,
        activeElectricityAgreementsCount: contact.activeElectricityAgreementsCount,
        averageElectricityAgreementsMonthlyFee: contact.averageElectricityAgreementsMonthlyFee,
        hasPendingElectricityAgreements: contact.hasPendingElectricityAgreements,
        summerGameSendNotification: contact.summerGameSendNotification,
        cardLoyalty: contact.cardLoyalty,
        customerId: contact.customerId,
        bankAccountNumber: contact.bankAccountNumber,
        eInvoice: contact.eInvoice,
        invoiceRecipientEmail: contact.invoiceRecipientEmail,
        electricityInvoiceRecipientEmail: contact.electricityInvoiceRecipientEmail,
        extendedSaleOrderDeadlineAllowed: contact.extendedSaleOrderDeadlineAllowed,
        defaultPaymentDeadline: contact.defaultPaymentDeadline,
        navirecToken: contact.navirecToken,
        navirecAccountId: contact.navirecAccountId,
        webAccess: contact.webAccess,
        webAdmin: contact.webAdmin,
        representative: contact.representative,
        canViewPin: contact.canViewPin,
        hasApplications: contact.hasApplications,
        blockingApplications: contact.blockingApplications ?? {},
        hasCreditAgreement: contact.hasCreditAgreement,
        timeUpdated: new Date().getTime()
    }
}
